<template>
  <div id="app" class="container">
    <h2>Please enter your address to continue

    </h2>
    <form @submit.prevent="submitForm" class="address-form">
      <!-- Street -->
      <div class="form-group full">
        <label for="street" class="form-label">Street</label>
        <input type="text" id="street" v-model="address.street" required class="form-control">
      </div>

      <!-- City -->
      <div class="form-group third">
        <label for="city" class="form-label">City</label>
        <input type="text" id="city" v-model="address.city" required class="form-control">
      </div>

      <!-- State -->
      <div class="form-group third">
        <label for="state" class="form-label">State/Province</label>
        <input type="text" id="state" v-model="address.state" required class="form-control">
      </div>

      <!-- Zip -->
      <div class="form-group third  last-child">
        <label for="zip" class="form-label">Postal Code</label>
        <input type="text" id="zip" v-model="address.zip" required class="form-control">
      </div>

      <!-- Country -->
      <div class="form-group full">
        <label for="country" class="form-label">Country</label>
        <input type="text" id="country" v-model="address.country" required class="form-control">
      </div>

      <button type="submit" class="btn-submit">Submit</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      address: {
        street: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      }
    };
  },
  methods: {
    submitForm() {

      this.success();
    },
    success() {
      this.$router.push(`/${this.$i18n.locale}/paymentInfo`);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.address-form {
  display: flex;
  flex-wrap: wrap;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
}

.form-group.full {
  width: 100%;
}



.form-group.third {
  width: 180px;
  margin-right: 10px;

}

.form-group.third.last-child {
  width: 180px;
  margin-right: 0px;
}

.form-label {
  text-align: left;
  margin-bottom: 0.5em;
}

.form-control {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-submit {
  padding: 10px 20px;
  background-color: #1bada2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}

.btn-submit:hover {
  background-color: #0ba6a1;
}
</style>
